import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { VPopover } from "v-tooltip";
import SelectFilter from "./application-status-select-filter";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationListFilters",
  components: {
    SelectFilter,
    VPopover
  },
  props: {
    isPropertyAccount: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      statuses: ["allStatuses", "new", "pending", "inReview", "completed", "cancelled"],
      selectedTags: {
        board: null,
        read: null,
        status: null
      },
      statusSelected: "allStatuses"
    };
  },
  watch: {
    isPropertyAccount(value) {
      if (!value) {
        this.handleChange("board", null);
      }
    }
  },
  methods: {
    handleChange(type, value) {
      switch (type) {
        case "board":
          this.selectedTags.board = value;
          break;
        case "client":
          {
            this.selectedTags.read = value;
            break;
          }
      }
      this.$emit("change", this.selectedTags);
    },
    handleSelectChange(data) {
      this.statusSelected = data.id;
      const status = data.id === "allStatuses" ? null : data.id;
      this.selectedTags.status = status;
      this.$emit("change", this.selectedTags);
    },
    clearFilter(data) {
      if (data === "status") this.statusSelected = "allStatuses";
      this.selectedTags = _objectSpread(_objectSpread({}, this.selectedTags), {}, {
        [data]: null
      });
    }
  }
});